import {
  formatCurrency,
  formatPercentage,
  formatNumber,
} from '@/utils/helpers';
import type { PricingSummary } from '@/services/valuation.service';

interface PricingPortfolioSummaryProps {
  summary: PricingSummary | null;
  currency?: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD';
}

export function PricingPortfolioSummary({
  summary,
  currency = 'USD',
}: PricingPortfolioSummaryProps) {
  return (
    <div
      className="bg-white rounded-lg shadow p-6"
      data-test-id="pricing-summary"
    >
      <h2 className="text-xl font-semibold mb-4">Portfolio Summary</h2>
      <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
        <div data-test-id="total-current-balance-field">
          <p className="text-sm text-gray-600">Total Current Balance</p>
          <p className="text-lg font-semibold">
            {formatCurrency(summary?.total_current_balance ?? '—', 2, currency)}
          </p>
        </div>
        <div data-test-id="total-fair-value-field">
          <p className="text-sm text-gray-600">Total Fair Value</p>
          <p className="text-lg font-semibold">
            {formatCurrency(summary?.total_fair_value ?? '—', 2, currency)}
          </p>
        </div>
        <div data-test-id="avg-price-pct-field">
          <p className="text-sm text-gray-600">Weighted Avg. Price %</p>
          <p className="text-lg font-semibold">
            {formatPercentage(summary?.avg_price_pct ?? '—', 3)}
          </p>
        </div>
        <div data-test-id="avg-wal-years-field">
          <p className="text-sm text-gray-600">Weighted Avg. WAL (Years)</p>
          <p className="text-lg font-semibold">
            {formatNumber(summary?.avg_wal_years, 2)}
          </p>
        </div>
        <div data-test-id="avg-effective-spread-bps-field">
          <p className="text-sm text-gray-600">
            Weighted Avg. Effective Spread (bps)
          </p>
          <p className="text-lg font-semibold">
            {formatNumber(summary?.avg_effective_spread_bps, 5)}
          </p>
        </div>
      </div>
    </div>
  );
}
